import Swal from 'sweetalert2';

/**
 *
 * @param {*} message
 */
export const showSuccess = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  });

  Toast.fire({
    type: 'success',
    title: message,
    icon: 'success',
  });
};
export const showFailure = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  });

  Toast.fire({
    type: 'warning',
    title: message,
    icon: 'warning',
  });
};

export const showInformation = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  Toast.fire({
    type: 'info',
    title: message,
    icon: 'info',
  });
};



// WEBPACK FOOTER //
// ./src/common/toast.js